import { __assign } from "tslib";
//ref: https://github.com/vercel/next.js/issues/43585
import nextRouter from 'next/compat/router';
import { getStringValue } from './utils/parser';
var browserPush = function (path) {
    window.location.href = path;
};
var browserReplace = function (path) {
    window.history.replaceState(null, '', path);
};
var useNavigation = function (router, parsers, routeInfo) {
    var _a, _b;
    if (router === void 0) { router = nextRouter; }
    var deepLinkHost = (_b = (_a = routeInfo === null || routeInfo === void 0 ? void 0 : routeInfo.manifest) === null || _a === void 0 ? void 0 : _a.deepLinkHost) !== null && _b !== void 0 ? _b : '';
    var buildURI = function (path, query, hash) {
        var _a = path.split('?'), originalPath = _a[0], _b = _a[1], originalQuery = _b === void 0 ? '' : _b;
        var querystring = new URLSearchParams(originalQuery.split('#')[0]);
        var buildedPath = Object.entries(query).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            var strValue = getStringValue(key, value, parsers, { encode: false });
            var paramRegExp = new RegExp("/(:|:\\?)".concat(key, "(/|$)"));
            var toReplace = (acc.match(paramRegExp) || [])[0];
            if (strValue) {
                if (toReplace) {
                    return acc.replace(toReplace, "/".concat(strValue).concat(toReplace.endsWith('/') ? '/' : ''));
                }
                else {
                    querystring.set(key, strValue);
                    return acc;
                }
            }
            return acc;
        }, originalPath);
        var preffix = buildedPath.startsWith('/') || buildedPath.startsWith('http') ? '' : "/";
        return "".concat(preffix).concat(Array.from(querystring.values()).length
            ? "".concat(buildedPath, "?").concat(querystring.toString())
            : buildedPath).concat(hash ? "#".concat(hash) : '');
    };
    var back = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.spa, spa = _c === void 0 ? true : _c;
        if (spa) {
            router.back();
        }
        else {
            window.history.back();
        }
    };
    var change = function (method, target, pushOptions, fallback) {
        var _a;
        var _b = typeof target === 'string' ? __assign(__assign({}, pushOptions), { path: target }) : target, path = _b.path, _c = _b.query, query = _c === void 0 ? {} : _c, hash = _b.hash, _d = _b.spa, spa = _d === void 0 ? true : _d, _e = _b.scroll, scroll = _e === void 0 ? true : _e, _f = _b.uriBuilder, uriBuilder = _f === void 0 ? buildURI : _f;
        if (!path)
            return;
        var uri = uriBuilder(path, query, hash);
        if (spa) {
            // https://magazine.atlassian.net/wiki/spaces/TWE/pages/4110090285/Rogue+Referral
            if ((_a = routeInfo === null || routeInfo === void 0 ? void 0 : routeInfo.manifest) === null || _a === void 0 ? void 0 : _a.cleanReferral) {
                try {
                    Object.defineProperty(document, 'referrer', {
                        value: '',
                        writable: true,
                    });
                }
                catch (_g) {
                    console.error('Unable to clean referrer');
                }
            }
            return router[method](uri, undefined, { scroll: scroll });
        }
        var host = deepLinkHost && !uri.startsWith('http') ? deepLinkHost : '';
        return fallback(host + uri);
    };
    var push = function (target, pushOptions) {
        if (target === void 0) { target = {}; }
        if (pushOptions === void 0) { pushOptions = {}; }
        change('push', target, pushOptions, browserPush);
    };
    var replace = function (target, pushOptions) {
        if (target === void 0) { target = {}; }
        if (pushOptions === void 0) { pushOptions = {}; }
        change('replace', target, pushOptions, browserReplace);
    };
    var refresh = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.spa, spa = _c === void 0 ? true : _c;
        if (spa) {
            router.reload();
        }
        else {
            var currentPath = "".concat(deepLinkHost).concat(window.location.pathname).concat(window.location.search);
            browserPush(currentPath);
        }
    };
    return {
        back: back,
        buildURI: buildURI,
        push: push,
        refresh: refresh,
        replace: replace,
    };
};
export default useNavigation;
//# sourceMappingURL=useNavigation.js.map